<div class="sidenav" *ngIf="filteredBlockingAmount" [ngClass]="(translate.currentLang=='en')?'dirLtr':'dirRtl'">
  <div style="    position: absolute;
  top: 2%;
  right: 4%;" (click)="close()">
    <button class="btn shadow-none">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-x-lg pdf-icon"
        viewBox="0 0 16 16">
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
      </svg>
    </button>
  </div>
  <h5 class="text-color-theme" style=" text-align: center;">
    <svg xmlns="http://www.w3.org/2000/svg" (click)="close()" width="16" height="16" fill="currentColor"
      class="bi bi-file-earmark-text" viewBox="0 0 16 16" style="vertical-align: 0%;">
      <path
        d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
      <path
        d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
    </svg>
    {{'purchase-power-details'|translate}}
    <p style="text-align: center; color: lightslategray;">{{currencySelection|translate}}</p>
  </h5>
  <div class="sideNavContent">
    <table class="table-striped table-footer-border-bottom text-color-theme " *ngIf="filteredBlockingAmount">
      <tr>
        <td></td>
        <td class="text-color-theme cell-style">{{'start-balance'|translate}}<hint-popover [key]="'start-balance-hint'"></hint-popover></td>
        <td [ngClass]="{'green':(filteredBlockingAmount?.bookbalance>0),
          'red':(filteredBlockingAmount?.bookbalance<0),
          
          'text-color-theme':(filteredBlockingAmount?.bookbalance==0)}">{{(filteredBlockingAmount?.bookbalance || 0)| number:
          "1.0":"en-US"}}</td>
      </tr>
      <tr>
        <td class="plus-icon-yellow"> + </td>
        <td class="text-color-theme cell-style">{{'today-sales'|translate}}<hint-popover [key]="'today-sales-hint'"></hint-popover></td>
        <td>{{(filteredBlockingAmount?.penSell || 0)| number: "1.0":"en-US"}}</td>
      </tr>
      <tr>
        <td class="plus-icon-yellow"> + </td>
        <td class="text-color-theme cell-style">{{'margin'|translate}} <hint-popover class="mx-2" [key]="'margin-hint-card'"></hint-popover></td>
        <td>{{(filteredBlockingAmount?.mrgLmt || 0)| number: "1.0":"en-US"}}</td>
      </tr>
      <tr>
        <td class="plus-icon-yellow"> + </td>
        <td class="text-color-theme cell-style">{{'day-limit'|translate}}</td>
        <td>{{(filteredBlockingAmount?.crdLmt || 0)| number: "1.0":"en-US"}}</td>
      </tr>
      <tr>
        <td style="color: rgb(31, 97, 158);
        font-size: 35px;
        padding: 0px 0px 0px 10px;
        text-align: center;
        height: 10px !important;"> - </td>
        <td class="text-color-theme cell-style">{{'buy-orders'|translate}} <hint-popover [key]="'buy-orders-hint'"></hint-popover></td>
        <td>{{(filteredBlockingAmount?.pendBuy || 0)| number: "1.0":"en-US"}}</td>
      </tr>
      <tr style="border-bottom: 1px white solid;">
        <td style="color: rgb(31, 97, 158);
        font-size: 35px;
        padding: 0px 0px 0px 10px;
        text-align: center;
        height: 10px !important;"> - </td>
        <td class="text-color-theme cell-style">{{'withdrawal-requests'|translate}} <hint-popover [key]="'withdrawal-requests-hint'"></hint-popover></td>
        <td>{{(filteredBlockingAmount?.withHeldAmt || 0)| number: "1.0":"en-US"}}</td>
      </tr>
      <tr>
        <td></td>
        <td class="text-color-theme cell-style">{{'purchase-power'|translate}}</td>
        <td [ngClass]="{'green':(purchasePower>0),
          'red':(purchasePower<0),
          'text-color-theme':(purchasePower==0)}">{{(purchasePower || 0)| number: "1.0":"en-US"}}</td>
      </tr>
    </table>

    <div class="avail-withdraw ">
      <h5 class="my-3">
        {{'withdrawalBalance'|translate}} 
      </h5>
      <div>
        <div class="d-flex justify-content-between mx-5 my-2 p-2">
          <div> {{'EGP'|translate}}</div>
          <div>{{ egpWithdraw || 0 | number}}</div>
        </div>
        <div class="d-flex justify-content-between mx-5 my-2 p-2">
          <div>{{'USD'|translate}}</div>
          <div> {{ usdWithdraw || 0 | number}}</div>
        </div>
      </div>
    </div>
  </div>

</div>
